import React, { useEffect, useState } from 'react';
import '../AddFire.scss';
import left from '../../../../assets/icons/left.png';
import Spinner from '../../../Spinner';
import { useUserContext }from '../../../../contexts/UserContext';
import { useFiresContext }from '../../../../contexts/FiresContext';
import axios from 'axios';
import * as turf from '@turf/turf';

export default function AddFireForm(props) {
    const {
      getToken
    } = useUserContext();

    const {
      setFires,
      fires,
      plotFires
    } = useFiresContext();

    const {
      map,
      setStage,
      perimeter,
      setPerimeter,
      draw,
      fire,
      setPanel
    } = props;

    const [addFireForm, setAddFireForm] = useState({
      fireName: '',
      status: '',
      cause: null,
      percontained: null,
      type: null,
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
      if (map.current && perimeter) {
          // Add the polygon as a read-only source/layer
          if (!map.current.getSource('Temporary Area Polygon Source')) {
              map.current.addSource('Temporary Area Polygon Source', {
                  type: 'geojson',
                  data: perimeter,
              });

              map.current.addLayer({
                  id: 'Temporary Area Polygon Layer',
                  type: 'fill',
                  source: 'Temporary Area Polygon Source',
                  paint: {
                      'fill-color': '#D20C0C',
                      'fill-opacity': 0.15,
                  },
              });

              map.current.addLayer({
                  id: 'Temporary Area Polygon Layer Outline',
                  type: 'line',
                  source: 'Temporary Area Polygon Source',
                  paint: {
                      'line-color': '#D20C0C',
                      'line-width': 2,
                  },
              });
          }
      }

      return () => {
          // Keep the polygon source and layers if going back to `add-perimeter`
          if (map.current && map.current.getSource('Temporary Area Polygon Source')) {
              map.current.removeLayer('Temporary Area Polygon Layer');
              map.current.removeLayer('Temporary Area Polygon Layer Outline');
              map.current.removeSource('Temporary Area Polygon Source');
          }
      };
    }, [map, perimeter]);

    const ringsToWKT = (rings) => {
      if(rings.length > 1) {
          const wkts = [];
          rings.forEach((poly) => {
              const list = [];
              poly.forEach((set) => {
                  list.push(set.toString().replace(',', '/'));
              });
              wkts.push(`POLYGON((${list.toString().replaceAll('/', ' ')}))`);
          });
          return wkts;
          
      } else {
          const list = [];
          rings[0].forEach((set) => {
              list.push(set.toString().replace(',', '/'));
          });
          return [`POLYGON((${list.toString().replaceAll('/', ' ')}))`];
      }
    }

    const WKTtoRings = (wkt) => {
      const rings = wkt.slice(9).slice(0, -2).split(',').map((coordinates) => {
          return coordinates.split(' ').filter((element) => element !== '').map((element) => parseFloat(element));
      });
      return rings;
    };

    const convertMetersToAcres = (areaInMetersSquared) => {
      const conversionFactor = 0.000247105;
      const areaInAcres = areaInMetersSquared * conversionFactor;
      return Math.round(areaInAcres * 100) / 100;
    };
  
    const addFire = () => {
      setError(false);
      setLoading(true);

      if (addFireForm.fireName.length === 0 || addFireForm.status.length === 0) {
        setLoading(false);
        setError('Please fill out required fields.');
        return;
      }

      let activeStatus;
  
      if (addFireForm.status === 'Active') {
        if (addFireForm.percontained === 100) {
          activeStatus = false;
        } else {
          activeStatus = true;
        }
      } else {
        if (!addFireForm.percontained) {
          activeStatus = false;
        } else if (addFireForm.percontained !== 100) {
          activeStatus = true;
        } else {
          activeStatus = false;
        }
      }
  
      getToken()
      .then((token) => {
        axios.post(`https://firewatch-api.space-eyes.com/fires`, {
          name: addFireForm.fireName,
          longitude: fire[1],
          latitude: fire[0],
          active: activeStatus,
          cause: addFireForm.cause,
          type: addFireForm.type,
          percontained: !activeStatus ? 100 : addFireForm.percontained,
          geom: perimeter ? ringsToWKT([perimeter.features[0].geometry.coordinates[0]])[0] : null,
          areaac: perimeter ? convertMetersToAcres(perimeter.features[0].properties.area) : null
        },
        {
          headers: {
              'Authorization': `Bearer ${token}`
          }
        }).then((res) => {
            setLoading(false);

            plotFires(map, [...fires, res.data.fire]);
            setFires((prevState) => [...prevState, res.data.fire]);

            console.log(res.data.fire)

            setPanel({
              name: 'Fire PopUp',
              content: res.data.fire
            });

            const rings = res.data.fire.geom ? WKTtoRings(res.data.fire.geom) : '';

            const geometry = {
              'type': 'Feature',
              'geometry': {
                'type': 'Polygon',
                'coordinates': [rings]
              }
            }

            const location = [res.data.fire.longitude, res.data.fire.latitude];

            if (!res.data.fire.geom) {
              map.current.flyTo({ center: location, pitch: 0, zoom: 17 });
            } else {
                map.current.fitBounds(turf.bbox(geometry), {
                    padding: 200,
                    pitch: 0
                });
            }

            setPerimeter(null);

            draw.current.deleteAll();
        }).catch((err) => {
            console.log('error adding new fire: ', err.message);
            setLoading(false);
            setError('Trouble adding fire. Please try again.');
        })
        }).catch((error) => {
            console.error('Failed to get token:', error);
            setLoading(false);
            setError('Trouble creating fire. Please try again.');
        });
    };

    const formatFireType = (type) => {
      switch (type) {
        case 'FI':
            return 'Fire Incident'
        case 'L':
            return 'Large Fire'
        case 'FM':
            return 'Fire Monitoring'
      }
    }
    
    return (
        <div 
            className='add-fire-content-instructions'
            style={{ marginTop: '0.1rem' }}
            >
            <div className='add-fire-back-btn' 
                onClick={() => {
                  setStage('add-perimeter');
                }}
            >
              <img 
                  src={left} 
                  className='add-fire-back-btn-icon'
              />
              Back
            </div>
            <div 
                className='add-fire-content-instructions-instruction'
                style={{ marginTop: '-0.5rem' }}
                >
                <div className='add-fire-content-instructions-instruction-title'>Step 3: Enter Fire Details</div>
                <div className='add-fire-content-form'>
                  <div className='add-fire-content-form-input-container'>
                    <div className='add-fire-content-form-input-container-title'>Fire Name - Required</div>
                    <input 
                      type='text'
                      value={addFireForm.fireName}
                      placeholder='Example: West Park Fire'
                      className='add-fire-content-form-input-container-input'
                      onChange={(e) => setAddFireForm((prevState) => ({ ...prevState, fireName: e.target.value }))}
                    />
                  </div>
                  <div className='add-fire-content-form-input-container'>
                    <div className='add-fire-content-form-input-container-title'>Status - Required</div>
                    <select
                        className='add-fire-content-form-input-container-select'
                        value={addFireForm.status}
                        onChange={(e) => setAddFireForm((prevState) => ({ ...prevState, status: e.target.value }))}
                        aria-label="add-fire"
                    >
                      <option value="" disabled>Select an option</option>
                      <option value="Active">Active</option>
                      <option value="Contained">Contained</option>
                    </select>
                  </div>
                  <div className='add-fire-content-form-input-container'>
                    <div className='add-fire-content-form-input-container-title'>Cause - Optional</div>
                    <select
                      className='add-fire-content-form-input-container-select'
                      value={addFireForm.cause || ""}
                      onChange={(e) => setAddFireForm((prevState) => ({ ...prevState, cause: e.target.value }))}
                      aria-label="add-fire"
                    >
                      <option value="" disabled>Select an option</option>
                      <option value="NATURAL">NATURAL</option>
                      <option value="HUMAN">HUMAN</option>
                      <option value="UNDETERMINED">UNDETERMINED</option>
                    </select>
                  </div>
                  <div className='add-fire-content-form-input-container'>
                    <div className='add-fire-content-form-input-container-title'>Type - Optional</div>
                    <select
                        className='add-fire-content-form-input-container-select'
                        value={addFireForm.type || ""}
                        onChange={(e) => setAddFireForm((prevState) => ({ ...prevState, type: e.target.value }))}
                        aria-label="add-fire"
                    >
                      <option value="" disabled>Select an option</option>
                      <option value="FI">{formatFireType('FI')}</option>
                      <option value="L">{formatFireType('L')}</option>
                      <option value="FM">{formatFireType('FM')}</option>
                    </select>
                  </div>
                  <div className='add-fire-content-form-input-container'>
                    <div className='add-fire-content-form-input-container-title'>Containment % - Optional</div>
                    <div className='add-fire-content-form-input-container-slider-container'>
                      <input
                        className='add-fire-content-form-input-container-slider-container-slider'
                        type="range" 
                        min="0" 
                        max="100" 
                        step="10"
                        value={addFireForm.percontained ? addFireForm.percontained : 0} 
                        onChange={(e) => setAddFireForm((prevState) => ({ ...prevState, percontained: e.target.value }))}
                      />
                      <div className='add-fire-content-form-input-container-slider-container-text'>{addFireForm.percontained !== null ? `${addFireForm.percontained}%` : 'N/A'}</div>
                    </div>
                  </div>
                  {error && <div className='add-fire-content-form-error'>{error}</div>}
                  {loading ?
                  <Spinner />
                  :
                  <button 
                    className='add-fire-content-instructions-instruction-next-btn'
                    style={{ marginTop: '0rem' }}
                    onClick={addFire}
                    >Add Fire
                  </button>}
                </div>
            </div>
        </div>
    )
}
